<div class="wraper" [formGroup]="form">
    <div class="login-area">
        <div [ngClass]="{'text-ltr':!languagesService.isRightToLeft,'text-rtl':languagesService.isRightToLeft}" class="input-area">
            <br>
            <div class="row">
                <div class="col-md-12 col-xs-12">
                    <input type="text" class="login-input" formControlName="social_id" placeholder="מספר תעודת זהות"/>
                    <br>
                    <control-messages [control]="f.social_id"></control-messages>
                </div>
            </div>
            
            <div class="row">
                <div class="col-md-12 col-xs-12">
                    <input type="text" class="login-input" formControlName="email" placeholder="דואר אלקטרוני" />
                    <br>
                    <control-messages [control]="f.email"></control-messages>
                </div>
            </div>
            <div class="row" *ngIf="error" style="
            color: #D8000C;
            margin-top: 5px;
            border: 1px ;">
                <div class="col-md-12 col-xs-12" >
                    <label >{{error}}</label>

                </div>

            </div>
            <div class="row-big"> 
                <div class="col-md-12 col-xs-12 ">             
                    <moia-captcha [isSubmitted]="isSubmitted" isFormValidation="true"></moia-captcha>    
                </div>       
            </div>
            <div class="row">
                <div class="col-md-12 col-xs-12">
                    <button class="login-btn" (click)="onSubmit()" [disabled]="form.invalid" >כניסה</button>
                    <br>
                </div>
            </div>
    
        </div>
    </div>    
</div>